import { request } from '@/utils/request';
import { IUserSession, IUserProfile, LOGGED_IN_STATUS, SEND_EMAIL_CODE_PURPOSE } from './types';
import { isUnauthorized } from '@/utils/error';

interface ILoginPayload {
  email: string;
  password: string;
  token: string;
}

interface IRegisterPayload {
  email: string;
  password: string;
  emailCode: string;
  token: string;
}

interface ISendEmailCodePayload {
  email: string;
  purpose: SEND_EMAIL_CODE_PURPOSE;
  token: string;
}

interface IResetPassword {
  email: string;
  newPassword: string;
  emailCode: string;
  token: string;
}

interface IUpdateUserNamePayload {
  username: string;
  token: string;
}

interface IUpdateUserPasswordPayload {
  oldPassword: string;
  newPassword: string;
  token: string;
}

interface IUpadateUserAvatarPayload {
  fileKey: string;
}

const login = async (payload: ILoginPayload) => {
  const res = await request.post<IUserProfile>('/auth/login', payload);
  return res.data.data;
};

const register = async (payload: IRegisterPayload) => {
  const res = await request.post<IUserProfile>('/auth/register', payload);
  return res.data.data;
};

const sendEmailCode = async (payload: ISendEmailCodePayload) => {
  const res = await request.post<boolean>('/auth/email/send-code', payload);
  return res.data.data;
};

const resetPassword = async (payload: IResetPassword) => {
  const res = await request.patch('/auth/password/reset', payload);
  return res.data.data;
};

const logout = async () => {
  const res = await request.delete<boolean>('/auth/logout');
  return res.data.data;
};

const getUserProfile = async () => {
  const res = await request.get<IUserProfile>('/user/profile');

  return res.data.data;
};

const updateUserName = async (payload: IUpdateUserNamePayload) => {
  const res = await request.patch<IUserProfile>('/user/profile', payload);
  return res.data.data;
};

const updateUserPassword = async (payload: IUpdateUserPasswordPayload) => {
  const res = await request.patch<IUserProfile>('/user/password', payload);
  return res.data.data;
};

const updateUserAvatar = async (payload: IUpadateUserAvatarPayload) => {
  const res = await request.patch<IUserProfile>('/user/avatar', payload);
  return res.data.data;
};

const getAuthStatus = async () => {
  const res = await request.get<IUserSession>('/auth/status');
  return res.data.data;
};

const getIsAuthorized = async () => {
  try {
    const res = await getAuthStatus();
    return res.loginStatus === LOGGED_IN_STATUS;
  } catch (err) {
    // 兜底：未登录时该接口返回的是 200 + loginStatus 0，走不到这里
    if (isUnauthorized(err)) {
      return false;
    }
    throw err;
  }
};

const getValidateEmailCodeStatus = async (email: string, code: string) => {
  const res = await request.post<boolean>(`/auth/verify_email_code`, {
    email,
    code
  });

  return res.data.data;
};

export {
  login,
  register,
  sendEmailCode,
  logout,
  resetPassword,
  getUserProfile,
  updateUserName,
  updateUserPassword,
  updateUserAvatar,
  getAuthStatus,
  getIsAuthorized,
  getValidateEmailCodeStatus
};
